import axios from 'axios';
import {Auth} from "../utils/Auth";

class Interceptor {

    static instance;
    apiClient = axios.create();
    auth = new Auth();

    static getInstance() {
        if (this.instance) {
            return this.instance.apiClient
        }
        return new Interceptor().apiClient
    }

    constructor() {
        this.apiClient.interceptors.request.use(
            async (config) => {
                const token = this.auth.getJwtToken();
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
                return config;
            },
            (error) => Promise.reject(error)
        );

    }
}

export default Interceptor;
